export const VIEW_TYPES = {
  disabled: "disabled",
  default: "default",
  defaultPositive: "default-positive",
  defaultNegative: "default-negative",
  actionPositive: "action-positive",
  actionNegative: "action-negative",
  clickPositive: "click-positive",
} as const;
